// Every country in the world (owner 2026-10-14: "just add every single
// country in that dropdown") — LV display name → flag-icons code (ISO 3166-1
// alpha-2, or a subdivision such as "gb-sct"). The name is what
// products.country stores, so the 44 names already in use keep their exact
// spelling (ASV, Lielbritānija, Dominikāna…); the rest use the standard
// Latvian names. Drives the admin country dropdown.
//
// KEEP IN SYNC with apps/storefront/src/lib/countries.ts (the storefront has
// no dependency on this package) — countries-sync.test.ts fails on drift.

export const COUNTRY_FLAG_CODES: Record<string, string> = {
  Afganistāna: "af",
  Albānija: "al",
  Alžīrija: "dz",
  Andora: "ad",
  Angilja: "ai",
  Anglija: "gb-eng",
  Angola: "ao",
  Antarktika: "aq",
  "Antigva un Barbuda": "ag",
  "Apvienotie Arābu Emirāti": "ae",
  Argentīna: "ar",
  Armēnija: "am",
  Aruba: "aw",
  ASV: "us",
  "ASV Mazās Aizjūras salas": "um",
  "ASV Samoa": "as",
  "ASV Virdžīnu salas": "vi",
  Austrālija: "au",
  Austrija: "at",
  Austrumtimora: "tl",
  Azerbaidžāna: "az",
  "Bahamu salas": "bs",
  Bahreina: "bh",
  Baltkrievija: "by",
  Bangladeša: "bd",
  Barbadosa: "bb",
  "Basku zeme": "es-pv",
  Beliza: "bz",
  Beļģija: "be",
  Benina: "bj",
  "Bermudu salas": "bm",
  Bolīvija: "bo",
  "Bosnija un Hercegovina": "ba",
  Botsvāna: "bw",
  Brazīlija: "br",
  "Britu Virdžīnas": "vg",
  Bruneja: "bn",
  Bulgārija: "bg",
  Burkinafaso: "bf",
  Burundija: "bi",
  Butāna: "bt",
  "Buvē sala": "bv",
  "Centrālāfrikas Republika": "cf",
  Čada: "td",
  Čehija: "cz",
  Čīle: "cl",
  Dānija: "dk",
  Dienvidāfrika: "za",
  "Dienviddžordžija un Dienvidsendviču salas": "gs",
  Dienvidkoreja: "kr",
  Dienvidsudāna: "ss",
  "Djego Garsijas atols": "dg",
  Dominika: "dm",
  Dominikāna: "do",
  Džērsija: "je",
  Džibutija: "dj",
  Ekvadora: "ec",
  "Ekvatoriālā Gvineja": "gq",
  Eritreja: "er",
  Etiopija: "et",
  Ēģipte: "eg",
  "Fēru salas": "fo",
  Fidži: "fj",
  Filipīnas: "ph",
  "Folklenda salas": "fk",
  Francija: "fr",
  "Francijas Dienvidjūru teritorija": "tf",
  "Francijas Gviāna": "gf",
  "Francijas Polinēzija": "pf",
  Gabona: "ga",
  Gajāna: "gy",
  Galisija: "es-ga",
  Gambija: "gm",
  Gana: "gh",
  Gērnsija: "gg",
  Gibraltārs: "gi",
  Grenāda: "gd",
  Grenlande: "gl",
  Grieķija: "gr",
  Gruzija: "ge",
  Guama: "gu",
  Gvadelupa: "gp",
  Gvatemala: "gt",
  Gvineja: "gn",
  "Gvineja-Bisava": "gw",
  Haiti: "ht",
  "Hērda sala un Makdonalda salas": "hm",
  Hondurasa: "hn",
  Horvātija: "hr",
  Igaunija: "ee",
  Indija: "in",
  "Indijas okeāna Britu teritorija": "io",
  Indonēzija: "id",
  Irāka: "iq",
  Irāna: "ir",
  Islande: "is",
  Itālija: "it",
  Izraēla: "il",
  Īrija: "ie",
  Jamaika: "jm",
  Japāna: "jp",
  Jaunkaledonija: "nc",
  Jaunzēlande: "nz",
  Jemena: "ye",
  Jordānija: "jo",
  Kaboverde: "cv",
  "Kaimanu salas": "ky",
  Kambodža: "kh",
  Kamerūna: "cm",
  Kanāda: "ca",
  "Kanāriju salas": "ic",
  Katalonija: "es-ct",
  Katara: "qa",
  Kazahstāna: "kz",
  Kenija: "ke",
  Kipra: "cy",
  Kirasao: "cw",
  Kirgizstāna: "kg",
  Kiribati: "ki",
  "Klipertona sala": "cp",
  "Kokosu (Kīlinga) salas": "cc",
  Kolumbija: "co",
  "Komoru salas": "km",
  "Kongo (Brazavila)": "cg",
  "Kongo (Kinšasa)": "cd",
  Kosova: "xk",
  Kostarika: "cr",
  Kotdivuāra: "ci",
  Krievija: "ru",
  Kuba: "cu",
  "Kuka salas": "ck",
  Kuveita: "kw",
  Ķīna: "cn",
  "Ķīnas īpašās pārvaldes apgabals Honkonga": "hk",
  "ĶTR īpašais administratīvais reģions Makao": "mo",
  Laosa: "la",
  Latvija: "lv",
  Lesoto: "ls",
  Libāna: "lb",
  Libērija: "lr",
  Lielbritānija: "gb",
  Lietuva: "lt",
  Lihtenšteina: "li",
  Lībija: "ly",
  Luksemburga: "lu",
  Madagaskara: "mg",
  Majota: "yt",
  Malaizija: "my",
  Malāvija: "mw",
  Maldīvija: "mv",
  Mali: "ml",
  Malta: "mt",
  Maroka: "ma",
  Martinika: "mq",
  Mauritānija: "mr",
  Maurīcija: "mu",
  "Māršala salas": "mh",
  Meksika: "mx",
  Melnkalne: "me",
  "Menas sala": "im",
  Mikronēzija: "fm",
  "Mjanma (Birma)": "mm",
  Moldova: "md",
  Monako: "mc",
  Mongolija: "mn",
  Montserrata: "ms",
  Mozambika: "mz",
  Namībija: "na",
  Nauru: "nr",
  Nepāla: "np",
  Nigēra: "ne",
  Nigērija: "ng",
  Nikaragva: "ni",
  Niue: "nu",
  Nīderlande: "nl",
  "Nīderlandes Karību salas": "bq",
  "Norfolkas sala": "nf",
  Norvēģija: "no",
  "Olandes salas": "ax",
  Omāna: "om",
  Pakistāna: "pk",
  Palau: "pw",
  "Palestīnas teritorijas": "ps",
  Panama: "pa",
  "Papua-Jaungvineja": "pg",
  Paragvaja: "py",
  Peru: "pe",
  "Pitkērnas salas": "pn",
  Polija: "pl",
  Portugāle: "pt",
  Puertoriko: "pr",
  Reinjona: "re",
  Rietumsahāra: "eh",
  Ruanda: "rw",
  Rumānija: "ro",
  Salvadora: "sv",
  Samoa: "ws",
  Sanmarīno: "sm",
  "Santome un Prinsipi": "st",
  "Saūda Arābija": "sa",
  "Seišelu salas": "sc",
  Senbartelmī: "bl",
  Senegāla: "sn",
  Senmartēna: "mf",
  "Senpjēra un Mikelona": "pm",
  "Sentkitsa un Nevisa": "kn",
  Sentlūsija: "lc",
  "Sentvinsenta un Grenadīnas": "vc",
  Serbija: "rs",
  Singapūra: "sg",
  Sintmārtena: "sx",
  Sīrija: "sy",
  Sjerraleone: "sl",
  Skotija: "gb-sct",
  Slovākija: "sk",
  Slovēnija: "si",
  Somālija: "so",
  Somija: "fi",
  Spānija: "es",
  Sudāna: "sd",
  Surinama: "sr",
  "Sv.Helēnas sala": "sh",
  "Svalbāra un Jana Majena sala": "sj",
  Svatini: "sz",
  Šrilanka: "lk",
  Šveice: "ch",
  Tadžikistāna: "tj",
  Taivāna: "tw",
  Taizeme: "th",
  Tanzānija: "tz",
  "Tērksas un Kaikosas salas": "tc",
  Togo: "tg",
  Tokelau: "tk",
  Tonga: "to",
  "Trinidada un Tobago": "tt",
  Trinidāda: "tt",
  Tunisija: "tn",
  Turcija: "tr",
  Turkmenistāna: "tm",
  Tuvalu: "tv",
  Uganda: "ug",
  Ukraina: "ua",
  Ungārija: "hu",
  Urugvaja: "uy",
  Uzbekistāna: "uz",
  Vanuatu: "vu",
  Vatikāns: "va",
  Vācija: "de",
  Velsa: "gb-wls",
  Venecuēla: "ve",
  Vjetnama: "vn",
  "Volisa un Futunas salas": "wf",
  Zambija: "zm",
  "Zālamana salas": "sb",
  Ziemeļīrija: "gb-nir",
  Ziemeļkoreja: "kp",
  Ziemeļmaķedonija: "mk",
  "Ziemeļu Marianas salas": "mp",
  "Ziemsvētku sala": "cx",
  Zimbabve: "zw",
  Zviedrija: "se",
};

export const COUNTRY_NAMES_LV = Object.keys(COUNTRY_FLAG_CODES).sort((a, b) =>
  a.localeCompare(b, "lv")
);
